import React, { useEffect, useState } from "react";

const API_BASE = "https://api.niveshly.com";

export default function AdminPositions() {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [position, setPosition] = useState("");

  useEffect(() => {
    fetch(`${API_BASE}/companies`)
      .then(res => res.json())
      .then(data => setCompanies(data));
  }, []);

  const handleSubmit = async () => {
    if (!selectedCompany || !position) {
      alert("Select Company and Position!");
      return;
    }

    await fetch(`${API_BASE}/update-position`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: selectedCompany,
        position: Number(position)
      })
    });

    alert("Position updated!");
    setPosition("");
  };

  return (
    <div style={{ padding: "30px", maxWidth: "450px", margin: "0 auto" }}>
      <h2 style={{ fontSize: "24px", color: "white", fontWeight: "700", marginBottom: "20px" }}>
        Admin: Set Top Stock Positions
      </h2>

      <label style={{ color: "white" }}>Choose Company</label>
      <select
        value={selectedCompany}
        onChange={(e) => setSelectedCompany(e.target.value)}
        style={{
          width: "100%",
          padding: "12px",
          marginTop: "8px",
          marginBottom: "15px",
          borderRadius: "8px",
          border: "1px solid #ccc",

        }}
      >
        <option value="">-- Select Company --</option>
        {companies.map((c, i) => (
          <option key={i} value={c.name}>
            {c.name}
          </option>
        ))}
      </select>

      <label style={{ color: "white" }}>Ranking Position (1 to 6)</label>
      <input
        type="number"
        min="1"
        max="6"
        value={position}
        onChange={(e) => setPosition(e.target.value)}
        style={{
          width: "100%",
          padding: "12px",
          marginTop: "8px",
          marginBottom: "20px",
          borderRadius: "8px",
          border: "1px solid #ccc"
        }}
      />

      <button
        onClick={handleSubmit}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#4f46e5",
          color: "white",
          border: "none",
          borderRadius: "10px",
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer",
        }}
      >
        Save Position
      </button>
    </div>
  );
}
